import * as React from 'react';
import styled, { css } from 'styled-components';

import { size } from '../layout/helpers';

const checkboxSize = size(2);
const dotSize = size(1.5);
const textSize = '1rem';
const textLineHeight = '1.5';

export const Label = styled.label`
  position: relative;
  display: flex;
  align-items: flex-start;
  font-size: ${textSize};
  line-height: ${textLineHeight};
  user-select: none;
  cursor: default;

  &::before {
    content: '';
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: ${checkboxSize};
    height: ${checkboxSize};
    margin-top: calc((${checkboxSize} - ${textSize} * ${textLineHeight}) / -2);
    background-color: var(--bg-body, ${(props) => props.theme.color.bg});
    border: 1px solid ${(props) => props.theme.color.borderAlt};
    font-size: 1rem;
    border-radius: 50%;
    cursor: pointer;
  }

  &::after {
    content: '';
    display: none;
    position: absolute;
    top: calc((${checkboxSize} - ${dotSize}) / 2);
    left: calc((${checkboxSize} - ${dotSize}) / 2);
    width: ${dotSize};
    height: ${dotSize};
    margin-top: calc((${checkboxSize} - ${textSize} * ${textLineHeight}) / -2);
    border-radius: 50%;
    background-color: var(--element-color, ${(props) => props.theme.color.primary});
  }
`;

export const LabelText = styled.div`
  flex: 1 1 auto;
  margin-left: ${size(1)};
`;

export const Wrapper = styled.div<{ error?: boolean }>`
  ${({ error }) =>
    error &&
    css`
      ${Label} {
        color: ${(props) => props.theme.color.ui.negative};

        &::before {
          background-color: ${(props) => props.theme.color.ui.negativeLight};
        }
      }
    `}
`;

export const Input = styled((props) => (
  <input {...props} className={`${props.checked ? 'checked' : undefined} ${props.className}`} />
)).attrs(({ type, checked }) => ({
  checked,
  type: type || 'radio',
}))`
  position: fixed;
  left: -9999px;
  opacity: 0;

  &[disabled] {
    & + ${Label} {
      opacity: 0.37;
      cursor: not-allowed;
    }
  }

  &:checked,
  &.checked {
    & + ${Label} {
      &::before {
        border-color: var(--element-color, ${(props) => props.theme.color.primary});
      }

      &::after {
        display: block;
      }
    }
  }

  &:focus,
  &:focus-visible {
    & + ${Label} {
      &::before {
        outline: 0.125rem solid var(--color-border-focus, #1959ca);
        outline-offset: var(--focus-outline-offset, 0.125rem);
      }
    }
  }
`;
